import type React from 'react'
import { Button } from 'antd'
import { StopOutlined } from '@ant-design/icons'

interface CancelButtonRendererProps {
  data: any
  onCancel: (jobId: string) => void
}

export const CancelButtonRenderer: React.FC<CancelButtonRendererProps> = ({ data, onCancel }) => {
  const cancellableStates = ['pending', 'queued', 'running']
  const isCancellable = cancellableStates.includes(data?.status?.toLowerCase())

  if (!isCancellable) {
    return null
  }

  return (
    <Button
      type='text'
      danger
      size='small'
      icon={<StopOutlined />}
      onClick={(e) => {
        e.stopPropagation()
        onCancel(data.id)
      }}
      title='Cancel Job'
    />
  )
}
